/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Sovereign_NameInputs */

const en_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Entity`)
};

const es_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entidad Sovereign`)
};

const fr_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entité Sovereign`)
};

const de_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Einheit`)
};

const ja_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign エンティティ`)
};

const zh_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 实体`)
};

const ar_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيان مستقل (Sovereign Entity)`)
};

const id_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitas Sovereign`)
};

const it_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entità Sovereign`)
};

const ru_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-сущность`)
};

const pt_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entidade Sovereign`)
};

const ko_tier_sovereign_name = /** @type {(inputs: Tier_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소버린 엔티티 (Sovereign Entity)`)
};

/**
* | output |
* | --- |
* | "Sovereign Entity" |
*
* @param {Tier_Sovereign_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_sovereign_name = /** @type {((inputs?: Tier_Sovereign_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Sovereign_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_sovereign_name(inputs)
	if (locale === "es") return es_tier_sovereign_name(inputs)
	if (locale === "fr") return fr_tier_sovereign_name(inputs)
	if (locale === "de") return de_tier_sovereign_name(inputs)
	if (locale === "ja") return ja_tier_sovereign_name(inputs)
	if (locale === "zh") return zh_tier_sovereign_name(inputs)
	if (locale === "ar") return ar_tier_sovereign_name(inputs)
	if (locale === "id") return id_tier_sovereign_name(inputs)
	if (locale === "it") return it_tier_sovereign_name(inputs)
	if (locale === "ru") return ru_tier_sovereign_name(inputs)
	if (locale === "pt") return pt_tier_sovereign_name(inputs)
	return ko_tier_sovereign_name(inputs)
});